
import {Component, Vue} from 'vue-property-decorator'

import { VCardTitle } from 'vuetify/lib'

@Component({
  name: 'CardTitle',
  extends: VCardTitle as any,
})
export default class CardTitle extends Vue {

}
